import React from "react";

import { renderDrawerText } from "../../../services/DisplayService";
import { renderRating } from "../../../services/ValueDataService";
import { BetQLSportItem } from "src/common-services";
import GameProjections from "src/components/GameProjections";

export interface TrendDawerProps {
  currentSport: BetQLSportItem;
  filterType: string;
  game: any;
  trendTitle: string;
  showData: boolean;
}

const TrendDrawer = (props: TrendDawerProps) => {
  const { currentSport, filterType, game, trendTitle, showData } = props;
  const periodFilter =
    filterType === "spread" || filterType === "moneyline" || filterType === "total" ? `FG${filterType}` : filterType;
  const trend = game[`max${periodFilter}Trend`];
  return showData ? (
    <React.Fragment>
      {currentSport[`has${periodFilter}PowerRating`] ? (
        <>
          {renderRating(game[`maxNew${periodFilter}Trend`], false)}
          <div>
            {renderDrawerText(
              game,
              filterType,
              "games-table-mobile-row__trend-drawer-title-text",
              "games-table-mobile-row__trend-drawer-body-text"
            )}
          </div>
        </>
      ) : null}
      <div
        style={{
          fontWeight: "bold",
          fontSize: 13,
          marginBottom: 15,
          color: "#262626",
        }}
      >
        {currentSport[`has${periodFilter}PowerRating`] && trend && trend.displayRating
          ? "Top Trend - " + trendTitle
          : trend && trend.displayRating
          ? trend.title
          : "No Trend"}
      </div>
      {trend && trend.displayRating ? (
        <div
          style={{
            fontWeight: 400,
            fontSize: 13,
            marginBottom: 15,
            color: "#515151",
          }}
        >
          {trend.description}
        </div>
      ) : (
        <div
          style={{
            fontWeight: 400,
            fontSize: 13,
            marginBottom: 15,
            color: "#515151",
          }}
        >
          No Trend
        </div>
      )}
      {game.projection ? <GameProjections slug={game.slugId} /> : null}
    </React.Fragment>
  ) : null;
};

export default TrendDrawer;
